function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "disk_svg__a",
  d: "M16.87 14.692l2.617 1.057-1.057 2.618-2.618-1.057 1.057-2.618zM11.293 9.47a2.824 2.824 0 11-2.823 2.823 2.814 2.814 0 012.823-2.823zm9.896-4.508l2.618 1.058-2.645 6.545-2.618-1.058 2.645-6.545zM11.294 1C5.057 1 0 6.057 0 12.294c0 6.238 5.057 11.294 11.294 11.294a11.294 11.294 0 0011.294-11.294C22.588 6.057 17.532 1 11.294 1z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  transform: "translate(0 -1)",
  xlinkHref: "#disk_svg__a"
});

function SvgDisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 23"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMjQgMjMiPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJNMTYuODcgMTQuNjkybDIuNjE3IDEuMDU3LTEuMDU3IDIuNjE4LTIuNjE4LTEuMDU3IDEuMDU3LTIuNjE4ek0xMS4yOTMgOS40N2EyLjgyNCAyLjgyNCAwIDExLTIuODIzIDIuODIzIDIuODE0IDIuODE0IDAgMDEyLjgyMy0yLjgyM3ptOS44OTYtNC41MDhsMi42MTggMS4wNTgtMi42NDUgNi41NDUtMi42MTgtMS4wNTggMi42NDUtNi41NDV6TTExLjI5NCAxQzUuMDU3IDEgMCA2LjA1NyAwIDEyLjI5NGMwIDYuMjM4IDUuMDU3IDExLjI5NCAxMS4yOTQgMTEuMjk0YTExLjI5NCAxMS4yOTQgMCAwMDExLjI5NC0xMS4yOTRDMjIuNTg4IDYuMDU3IDE3LjUzMiAxIDExLjI5NCAxeiIvPjwvZGVmcz48dXNlIGZpbGw9ImN1cnJlbnRDb2xvciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMSkiIHhsaW5rOmhyZWY9IiNhIi8+PC9zdmc+Cg==";
export { SvgDisk as ReactComponent };